module.exports = __webpack_public_path__ + "assets/img/standard-active.494690af.svg";